import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class FormWebsiteError extends React.Component {
    render() {
        return (
            <FormattedMessage id={this.props.field_name}>
                {
                    (field) =>
                        <FormattedMessage id={"CMS.Form.field.website"} values={{ field: field }}>
                            {
                                (message) => <p>{message}</p>
                            }
                        </FormattedMessage>
                }
            </FormattedMessage>
        );
    }
}
FormWebsiteError.propTypes = {
    field_name: PropTypes.string.isRequired,
};
export default FormWebsiteError